import type { ModalActionHandler } from './modalActionTypes';
import { assignJob, getFreePopulation, MAX_BUILDERS } from '../map/settlement';
import { getSettlement } from './settlementActionUtils';

export const hireBuilderAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement) return false;
    const freePop = getFreePopulation(settlement);
    if (settlement.jobs.builders >= MAX_BUILDERS || freePop <= 0) return false;
    if (!assignJob(settlement, 'builders')) return false;
    return true;
};
